import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';
import { AutoprolongContainer } from './components/Autoprolong';
import { ContentContainer } from './components/Content';
import { Details } from './components/Details';
import { Footer } from './components/Footer';
import { useSelector } from 'react-redux';
import { selectIsSubscription } from '../../selectors/buyPackageModal';
import { getTitle } from './utils';

interface IProps {
  onClose(): void;
}

export const BuyConfirmationModalMobileContainer = (props: IProps) => {
  const { onClose } = props;

  const isSubscription = useSelector(selectIsSubscription);

  const title = getTitle(isSubscription);

  return (
    <ModalWindow open onClose={onClose} title={title}>
      <ContentContainer />

      <Details />

      <AutoprolongContainer />

      <Footer />
    </ModalWindow>
  );
};
